// Imports
import firebase from '../config/FirebaseConfig'

// Setup
const db = firebase.firestore()

// Pins are stored as 'YYYY-MM-DD' strings. Legacy pins were stored as epoch millis.
const DATE_STRING_REGEX = /^\d{4}-\d{2}-\d{2}$/

const getPinnedCreativeTestDays = async (brandId) => {
  const user = firebase.auth().currentUser
  if (!user) return []

  const querySnapshot = await db.collection('pinned-creative-tests')
    .where('userId', '==', user.uid)
    .where('brandId', '==', brandId)
    .get()

  if (querySnapshot.empty) return []

  const doc = querySnapshot.docs[0]
  const creativeTestDays = doc.data().creativeTestDays ?? []

  return creativeTestDays.filter((date) => DATE_STRING_REGEX.test(date))
}

const pinCreativeTestDay = async (brandId, date) => {
  const user = firebase.auth().currentUser
  if (!user) return

  const querySnapshot = await db.collection('pinned-creative-tests')
    .where('userId', '==', user.uid)
    .where('brandId', '==', brandId)
    .get()

  if (querySnapshot.empty) {
    await db.collection('pinned-creative-tests').add({
      userId: user.uid,
      brandId,
      creativeTestDays: [date]
    })
  } else {
    const doc = querySnapshot.docs[0]
    await doc.ref.update({
      creativeTestDays: firebase.firestore.FieldValue.arrayUnion(date)
    })
  }
}

const unpinCreativeTestDay = async (brandId, date) => {
  const user = firebase.auth().currentUser
  if (!user) return

  const querySnapshot = await db.collection('pinned-creative-tests')
    .where('userId', '==', user.uid)
    .where('brandId', '==', brandId)
    .get()

  if (querySnapshot.empty) return

  const doc = querySnapshot.docs[0]
  await doc.ref.update({ 
    creativeTestDays: firebase.firestore.FieldValue.arrayRemove(date) 
  })
}

// =========== OLD SPYDER SERVICES (DEPRECATED) ==========

// Get fb_ads_page_track
const getByPageId = async (pageId) => {
  const snapshot = await db
    .collection('fb_ads_page_track')
    .where('pageId', '==', pageId)
    .limit(1)
    .get()

  const spyderInstance = snapshot.docs[0]

  return {
    ...spyderInstance.data(),
    id: spyderInstance.id
  }
}

// Update fb_ads_page_track
const update = (spyderId, payload) => {
  return db
    .collection('fb_ads_page_track')
    .doc(spyderId)
    .update(payload)
}

// Adds new doc to fb_ads_page_track
const create = (payload) => {
  return db
    .collection('fb_ads_page_track')
    .add(payload)
}

// Check if user is tracking a brand
const checkIsTrackingBrand = async (subscriptionId, brandId) => {
  const snapshot = await db
    .collection('fb_ads_page_track')
    .where('brandId', '==', brandId)
    .get()

  const brandSubscription = snapshot.docs?.[0]?.data()
  if (!brandSubscription) return false

  return brandSubscription.subscribers.includes(subscriptionId)
}

export default {
  getPinnedCreativeTestDays,
  pinCreativeTestDay,
  unpinCreativeTestDay,
  // Old spyder services (DEPRECATED)
  create,
  getByPageId,
  update,
  checkIsTrackingBrand
}
